import { render, staticRenderFns } from "./I2FormInputDate.vue?vue&type=template&id=679e25fe"
import script from "./I2FormInputDate.vue?vue&type=script&lang=js"
export * from "./I2FormInputDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports